export class UserHasModuleStruct {
    public idModule: number;
    public userHasModule: boolean;
}